export default __webpack_public_path__ + "static/media/slide1.c18d97aa.jpg";